"use client";

import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";
import { db } from "@/lib/db";

export default function ThemeSwitch() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // useEffect_runs_after_paint, setting mounted true here is fine
  // the warning is for *synchronous* set states that trigger re-renders
  // before the initial render.
  useEffect(() => {
    setMounted(true);
  }, []);

  // Render a stable placeholder before mount so parent headers/layouts never
  // see a sudden `null` removal and re-insertion during hydration.
  if (!mounted) {
    return (
      <span
        className="relative h-9 w-16 inline-block"
        aria-label="Toggle Theme"
      />
    );
  }

  const isDark = theme === "dark";

  return (
    <button
      onClick={async () => {
        setTheme(isDark ? "light" : "dark");
        await db.save({
          action: "change_theme",
          theme: isDark ? "light" : "dark",
        });
      }}
      className="relative h-9 w-16 rounded-full bg-gradient-to-r from-y/20 to-y/10 border border-y/30 p-1 transition-all hover:border-y hover:shadow-[0_0_20px_rgba(255,214,0,0.2)]"
      aria-label="Toggle Theme"
    >
      <motion.div
        animate={{
          x: isDark ? 0 : 28,
          backgroundColor: isDark ? "#FFD600" : "#0A0A0A",
        }}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
        className="h-7 w-7 rounded-full flex items-center justify-center shadow-lg"
      >
        <motion.div
          animate={{ rotate: isDark ? 0 : 180, scale: isDark ? 1 : 0.8 }}
          transition={{ duration: 0.3 }}
        >
          {isDark ? (
            <Moon className="h-4 w-4 text-black" />
          ) : (
            <Sun className="h-4 w-4 text-y" />
          )}
        </motion.div>
      </motion.div>
    </button>
  );
}
